
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["arrearsOrder_svg__icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 1024 1024","xmlns":"http://www.w3.org/2000/svg","width":"128","height":"128"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M421.8 566.2h-157c-23.7.6-43.4-18.2-44-41.9v-2.1c1.4-20.2 17.5-36.3 37.7-37.7h157.1c20.2 1.4 36.3 17.5 37.7 37.7 12.4 25.2-6.4 44-31.5 44zm0 201h-157c-20.8 0-37.7-16.9-37.7-37.7s16.9-37.7 37.7-37.7h156.9c20.2 1.4 36.3 17.5 37.7 37.7 6.3 18.8-12.5 37.9-37.7 37.9v-.2zm-157-483.6h477.3c20.2 1.4 36.3 17.5 37.7 37.7-1.4 20.2-17.5 36.3-37.7 37.7H264.8c-20.2-1.4-36.3-17.5-37.7-37.7-6.3-18.8 12.6-37.7 37.7-37.7zm520.9 270.1c58.7-.6 115.3 21.9 157.6 62.8V264.7c1.4-109.6-86.4-199.5-195.9-200.9H264.8C155.2 62.4 65.2 150 63.8 259.6v482.5c-1.5 109.6 86 199.6 195.6 201.2h338.2c-32.3-43.6-50-96.4-50.3-150.7-2.2-129.6 100.9-236.5 230.5-238.7h8.2l-.3-.2z"}}),_c('path',{attrs:{"d":"M862.6 786c-.5 7.5-6.5 13.4-13.9 13.9h-41.8v20.9h41.8c7.7.1 13.9 6.4 13.8 14-.1 7.6-6.2 13.8-13.8 13.8h-41.8v13.9c.1 11.5-9.2 21-20.7 21.1-11.5.1-21-9.2-21.1-20.7v-14.2h-41.8c-7.7-.1-13.9-6.4-13.8-14 .1-7.6 6.2-13.8 13.8-13.8h41.8V800h-41.8c-7.7-.1-13.9-6.4-13.8-14 .1-7.6 6.2-13.8 13.8-13.8h20.9l-20.9-48.8c-6.8-13.9 0-27.9 20.9-27.9 6.8 0 13.9 6.8 20.9 13.9 7.9 19.3 17.2 37.9 27.9 55.7 7.9-19.3 17.2-37.9 27.9-55.7 0-6.8 6.8-13.9 20.9-13.9 14.1 0 27.9 13.9 20.9 27.9l-41.8 41.8h20.9c10.1-1.4 19.5 5.6 20.9 15.7.2 1.6.2 3.4-.1 5.1zM786 611.8c-96.2 0-174.2 78-174.2 174.2 0 96.2 78 174.2 174.2 174.2 96.2 0 174.2-78 174.2-174.2.9-95.3-75.5-173.3-170.8-174.2H786z"}})])
          )
        }
      }
    